'use client';

import {createContext, FC, ReactNode, useContext, useState} from "react";
import {Specialization} from "@web-libs/features/appointments/domain/appointment.types";
import {useRepositories} from "@web-libs/core/repositories/application/repository-concerns";

interface SpecializationConcern {
    specializations: Specialization[]
    fetchSpecializations: (instId: string) => Promise<Specialization[]>
}

const SpecializationContext = createContext<SpecializationConcern | null>(null)

const useCreateSpecializationConcern = (): SpecializationConcern => {
    const {getRepo} = useRepositories()
    const specializationRepository = getRepo('GeneralSpecializationRepository')

    const [specializations, setSpecializations] = useState<Specialization[]>([])

    const fetchSpecializations = async (instId: string): Promise<Specialization[]> => {
        const fetchedSpecs = await specializationRepository.getSpecializations(instId)
        setSpecializations(fetchedSpecs)
        return fetchedSpecs;
    }

    return {
        specializations,
        fetchSpecializations
    }
}

export const SpecializationProvider = ({children}:{children:ReactNode}) => {
    const specializationConcern = useCreateSpecializationConcern()
    return (
      <SpecializationContext.Provider value={specializationConcern}>
            {children}
        </SpecializationContext.Provider>
    )
}

export const useSpecialization = (): SpecializationConcern => {
    const specializationConcern = useContext(SpecializationContext)
    if (!specializationConcern) {
        throw new Error('useSpecialization must be used within a SpecializationProvider')
    }
    return specializationConcern
}
